module.exports = __webpack_public_path__ + "img/bg_avatar_male_98.3b30e312.png";